import { flashcardConstants } from '../../constants/flashcard.constants';
import { flashcardService } from '../../services';
import { notificationActions } from './notification.actions';

// ==================== FOLDERS ====================

const getAllFolders = () => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const folders = await flashcardService.getAllFolders();
      dispatch(success(folders));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: flashcardConstants.GET_ALL_FOLDERS_REQUEST };
  }
  function success(folders: any) {
    return { type: flashcardConstants.GET_ALL_FOLDERS_SUCCESS, payload: folders };
  }
  function failure(error: any) {
    return { type: flashcardConstants.GET_ALL_FOLDERS_FAILURE, error };
  }
};

const createFolder = (formData: any) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const folder = await flashcardService.createFolder(formData);
      dispatch(success(folder));
      dispatch(notificationActions.addNotification('Tạo folder thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: flashcardConstants.CREATE_FOLDER_REQUEST };
  }
  function success(folder: any) {
    return { type: flashcardConstants.CREATE_FOLDER_SUCCESS, payload: folder };
  }
  function failure(error: any) {
    return { type: flashcardConstants.CREATE_FOLDER_FAILURE, error };
  }
};

const updateFolder = (folderId: number, formData: any) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const folder = await flashcardService.updateFolder(folderId, formData);
      dispatch(success(folder));
      dispatch(notificationActions.addNotification('Cập nhật folder thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: flashcardConstants.UPDATE_FOLDER_REQUEST };
  }
  function success(folder: any) {
    return { type: flashcardConstants.UPDATE_FOLDER_SUCCESS, payload: folder };
  }
  function failure(error: any) {
    return { type: flashcardConstants.UPDATE_FOLDER_FAILURE, error };
  }
};

const deleteFolder = (folderId: number) => {
  return async (dispatch: any) => {
    try {
      await flashcardService.deleteFolder(folderId);
      dispatch(success(folderId));
      dispatch(notificationActions.addNotification('Xóa folder thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function success(folderId: number) {
    return { type: flashcardConstants.DELETE_FOLDER_SUCCESS, payload: folderId };
  }
  function failure(error: any) {
    return { type: flashcardConstants.DELETE_FOLDER_FAILURE, error };
  }
};

// ==================== SETS ====================

const getAllSets = () => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const sets = await flashcardService.getAllSets();
      dispatch(success(sets));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: flashcardConstants.GET_ALL_SETS_REQUEST };
  }
  function success(sets: any) {
    return { type: flashcardConstants.GET_ALL_SETS_SUCCESS, payload: sets };
  }
  function failure(error: any) {
    return { type: flashcardConstants.GET_ALL_SETS_FAILURE, error };
  }
};

const getSetsByFolder = (folderId: number) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const sets = await flashcardService.getAllSets();
      const filteredSets = sets.filter((s: any) => s.folder_id === folderId);
      dispatch(success(filteredSets));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: flashcardConstants.GET_SETS_BY_FOLDER_REQUEST };
  }
  function success(sets: any) {
    return { type: flashcardConstants.GET_SETS_BY_FOLDER_SUCCESS, payload: sets };
  }
  function failure(error: any) {
    return { type: flashcardConstants.GET_SETS_BY_FOLDER_FAILURE, error };
  }
};

const createSet = (formData: any) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const set = await flashcardService.createSet(formData);
      dispatch(success(set));
      dispatch(notificationActions.addNotification('Tạo set từ thành công!', 'SUCCESS'));
        return set; // Return set for use in component
      } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
        throw error;
    }
  };

  function request() {
    return { type: flashcardConstants.CREATE_SET_REQUEST };
  }
  function success(set: any) {
    return { type: flashcardConstants.CREATE_SET_SUCCESS, payload: set };
  }
  function failure(error: any) {
    return { type: flashcardConstants.CREATE_SET_FAILURE, error };
  }
};

const updateSet = (setId: number, formData: any) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const set = await flashcardService.updateSet(setId, formData);
      dispatch(success(set));
      dispatch(notificationActions.addNotification('Cập nhật set từ thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: flashcardConstants.UPDATE_SET_REQUEST };
  }
  function success(set: any) {
    return { type: flashcardConstants.UPDATE_SET_SUCCESS, payload: set };
  }
  function failure(error: any) {
    return { type: flashcardConstants.UPDATE_SET_FAILURE, error };
  }
};

const deleteSet = (setId: number) => {
  return async (dispatch: any) => {
    try {
      await flashcardService.deleteSet(setId);
      dispatch(success(setId));
      dispatch(notificationActions.addNotification('Xóa set từ thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function success(setId: number) {
    return { type: flashcardConstants.DELETE_SET_SUCCESS, payload: setId };
  }
  function failure(error: any) {
    return { type: flashcardConstants.DELETE_SET_FAILURE, error };
  }
};

// ==================== CARDS ====================

const getCardsBySet = (setId: number) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const cards = await flashcardService.getCardsBySet(setId);
      dispatch(success(cards));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: flashcardConstants.GET_CARDS_BY_SET_REQUEST };
  }
  function success(cards: any) {
    return { type: flashcardConstants.GET_CARDS_BY_SET_SUCCESS, payload: cards };
  }
  function failure(error: any) {
    return { type: flashcardConstants.GET_CARDS_BY_SET_FAILURE, error };
  }
};

const createCard = (setId: number, formData: any) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const card = await flashcardService.createCard(setId, formData);
      dispatch(success(card));
      dispatch(notificationActions.addNotification('Tạo thẻ thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: flashcardConstants.CREATE_CARD_REQUEST };
  }
  function success(card: any) {
    return { type: flashcardConstants.CREATE_CARD_SUCCESS, payload: card };
  }
  function failure(error: any) {
    return { type: flashcardConstants.CREATE_CARD_FAILURE, error };
  }
};

const bulkCreateCards = (setId: number, cards: any[]) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const createdCards = await flashcardService.bulkCreateCards(setId, cards);
      dispatch(success(createdCards));
      dispatch(notificationActions.addNotification('Tạo thẻ thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: flashcardConstants.BULK_CREATE_CARDS_REQUEST };
  }
  function success(cards: any) {
    return { type: flashcardConstants.BULK_CREATE_CARDS_SUCCESS, payload: cards };
  }
  function failure(error: any) {
    return { type: flashcardConstants.BULK_CREATE_CARDS_FAILURE, error };
  }
};

const updateCard = (cardId: number, formData: any) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const card = await flashcardService.updateCard(cardId, formData);
      dispatch(success(card));
      return card;
      // Don't show notification for bulk updates
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error; // Re-throw to let caller handle
    }
  };

  function request() {
    return { type: flashcardConstants.UPDATE_CARD_REQUEST };
  }
  function success(card: any) {
    return { type: flashcardConstants.UPDATE_CARD_SUCCESS, payload: card };
  }
  function failure(error: any) {
    return { type: flashcardConstants.UPDATE_CARD_FAILURE, error };
  }
};

const deleteCard = (cardId: number) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      await flashcardService.deleteCard(cardId);
      dispatch(success(cardId));
      // Don't show notification for bulk deletes
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request() {
    return { type: flashcardConstants.DELETE_CARD_REQUEST };
  }
  function success(cardId: number) {
    return { type: flashcardConstants.DELETE_CARD_SUCCESS, payload: cardId };
  }
  function failure(error: any) {
    return { type: flashcardConstants.DELETE_CARD_FAILURE, error };
  }
};

// ==================== SELECTION ====================

const selectFolder = (folderId: number | null) => {
  return { type: flashcardConstants.SELECT_FOLDER, payload: folderId };
};

const clearSelection = () => {
  return { type: flashcardConstants.CLEAR_SELECTION };
};

// ==================== OLD FLASHCARD PDF (submitText) ====================
// Giữ để backward compatibility với LessonDiary và FlashCardPDF components

const SUBMIT_REQUEST = 'SUBMIT_REQUEST';
const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
const SUBMIT_FAILURE = 'SUBMIT_FAILURE';

export const submitText = ({...obj}: any) => {
  return async (dispatch: any) => {
    dispatch({ type: SUBMIT_REQUEST });

    try {
      const fileName = obj.fileName || 'flashcard';
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/teachers/flashcard-pdf`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({vocabs: obj.vocabs, withPhonics : obj.withPhonics})
      });
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName || 'flashcard'}.pdf`);
      document.body.appendChild(link);
      link.click();
      if (link.parentNode) link.parentNode.removeChild(link);
      
      dispatch({ type: SUBMIT_SUCCESS, payload: url });
    } catch (error: any) {
      dispatch({ type: SUBMIT_FAILURE, payload: error.message });
    }
  };
};

export const flashcardActions = {
  getAllFolders,
  createFolder,
  updateFolder,
  deleteFolder,
  getAllSets,
  getSetsByFolder,
  createSet,
  updateSet,
  deleteSet,
  getCardsBySet,
  createCard,
  bulkCreateCards,
  updateCard,
  deleteCard,
  selectFolder,
  clearSelection,
  submitText, // Backward compatibility
};
